import { render, staticRenderFns } from "./NeedsAttentionCard.vue?vue&type=template&id=077f3545&scoped=true"
import script from "./NeedsAttentionCard.vue?vue&type=script&lang=js"
export * from "./NeedsAttentionCard.vue?vue&type=script&lang=js"
import style0 from "./NeedsAttentionCard.vue?vue&type=style&index=0&id=077f3545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f3545",
  null
  
)

export default component.exports